import { gql } from "@outschool/ui-apollo";

const ContentfulTutoringPageCollectionQuery = gql`
  query ContentfulTutoringPage($locale: String, $preview: Boolean) {
    contentfulTutoringPageCollection(
      limit: 1
      skip: 0
      preview: $preview
      locale: $locale
    ) {
      items {
        title
        visualLinkGridsCollection {
          items {
            title
            style
            visualLinksCollection {
              items {
                text
                path
                image {
                  url
                }
                imageAltText
                imageAspectRatio
              }
            }
          }
        }
        articlesCollection {
          items {
            magnetPageSlug
            categoryLabel {
              value
            }
            title
            author {
              name
              profileImage {
                url
              }
            }
            headerImage {
              url(
                transform: { quality: 85, width: 692, height: 302, format: JPG }
              )
            }
          }
        }
        popularTutoringSubjectsCollection {
          items {
            text
            image {
              url
            }
            path
            pathB
          }
        }
      }
    }
  }
`;

export default ContentfulTutoringPageCollectionQuery;
